// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-p"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 12.5V5H15C15.5523 5 16 5.44772 16 6V11.5C16 12.0523 15.5523 12.5 15 12.5H8ZM8 12.5V19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersPIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-p',
    ref,
    icon: element,
  },
));

LettersPIcon.displayName = 'LettersPIcon';

export default LettersPIcon;
